<template>
  <v-container fluid>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout column wrap v-else>
      <v-toolbar
        color="#eee"
        class="elevation-0 secondary--text mb-4"
        style="background: transparent"
      >
        <v-toolbar-title>
          Contatos Apetrus Tec
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-slide-x-transition>
          <v-layout justify-end v-show="searching">
            <v-flex xs1>
              <v-tooltip bottom>
                <v-btn
                  icon
                  color="info"
                  @click="carregarContatos(true)"
                  slot="activator"
                >
                  <v-icon>search</v-icon>
                </v-btn>
                <span>Pesquisar</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs3>
              <v-select
                outline
                hide-details
                single-line
                placeholder="Filtrar por"
                :items="filtros"
                item-value="value"
                item-text="text"
                v-model="filtro"
              ></v-select>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                outline
                hide-details
                single-line
                :readonly="!filtro"
                v-model="campoPesquisa"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-slide-x-transition>
        <v-btn icon color="info" @click="searching = !searching">
          <v-icon v-if="!searching">search</v-icon>
          <v-icon v-else>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="contatos"
          :loading="loading"
          hide-actions
          :disable-sort="true"
          class="elevation-1"
        >
          <template v-slot:headers>
            <tr>
                <th
                v-for="header in headers"
                :key="header.value"
                class="text-xs-center"
                >
                {{ header.text }}
                </th>
            </tr>
            </template>
            <template v-slot:items="props">
            <tr>
                <td
                v-for="header in headers"
                :key="header.value"
                class="text-xs-center"
                >
                <!-- data -->
                <span v-if="header.value === 'data_criacao'">
                    {{ formatDate(props.item[header.value]) }}
                </span>
                <!-- telefone -->
                <span v-else-if="header.value === 'telefone'">
                    {{ maskTelefone(props.item[header.value]) }}
                </span>
                <!-- landing page -->
                <span v-else-if="header.value === 'landingPage'">
                    {{ props.item[header.value] === true ? 'Sim' : props.item[header.value] === false ? 'Não' : 'Não informado' }}
                </span>
                <!-- comercializacao -->
                <span v-else-if="header.value === 'comercializacao'">
                    {{ props.item[header.value] === 1 ? 'Para a empresa' : props.item[header.value] === 2 ? 'Para comercialização' : 'Não informado' }}
                </span>
                <!-- aplicacao -->
                <span v-else-if="header.value === 'aplicacao'">
                    {{ props.item[header.value] === 1 ? 'Aplicativo' : props.item[header.value] === 2 ? 'Site' : props.item[header.value] === 3 ? 'Ambos' : 'Não informado' }}
                </span>
                <span v-else>
                    {{ props.item[header.value] !== null && props.item[header.value] !== undefined && props.item[header.value] !== '' ? props.item[header.value] : 'Não informado' }}
                </span>
                </td>
            </tr>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'

export default {
  components: {
    SmartLockMessage
  },
  data () {
    return {
      contatos: [],
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Nome', value: 'nome', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Telefone', value: 'telefone', sortable: false },
        { text: 'Nome do Projeto', value: 'nome_projeto', sortable: false },
        { text: 'Mensagem', value: 'mensagem', sortable: false },
        { text: 'Comercialização', value: 'comercializacao', sortable: false },
        { text: 'Landing Page', value: 'landingPage', sortable: false },
        { text: 'Aplicação', value: 'aplicacao', sortable: false },
        { text: 'Data de Criação', value: 'data_criacao', sortable: false }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      totalItems: 0,
      searching: false,
      filtros: [
        { value: 'nome', text: 'Nome' },
        { value: 'email', text: 'Email' },
        { value: 'telefone', text: 'Telefone' }
      ],
      campoPesquisa: '',
      filtro: ''
    }
  },
  computed: {
    smartLock () {
      return this.$store.getters.smartLock
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      if (!this.pagination.rowsPerPage || !this.totalItems) return 1
      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return ''
      const d = new Date(date)
      const dia = String(d.getDate()).padStart(2, '0')
      const mes = String(d.getMonth() + 1).padStart(2, '0')
      const ano = d.getFullYear()
      const hora = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      return `${dia}/${mes}/${ano} ${hora}:${min}`
    },
    maskTelefone (telefone) {
      if (!telefone) return 'Não informado'
      let tel = telefone.replace(/\D/g, '')
      if (tel.startsWith('55') && tel.length > 11) {
        tel = tel.slice(2)
      }
      if (tel.length === 11) {
        return `(${tel.slice(0, 2)}) ${tel.slice(2, 7)}-${tel.slice(7, 11)}`
      } else if (tel.length === 10) {
        return `(${tel.slice(0, 2)}) ${tel.slice(2, 6)}-${tel.slice(6, 10)}`
      }
      return telefone
    },
    carregarContatos (zerarPaginacao) {
      let data = {
        page: zerarPaginacao ? 1 : this.pagination.page,
        page_size: this.pagination.rowsPerPage
      }
      if (this.campoPesquisa && this.filtro) {
        data[this.filtro] = this.campoPesquisa
      }
      this.$store.dispatch('pegarContatosApetrusTec', data)
        .then(json => {
          if (json && Array.isArray(json.results)) {
            this.contatos = json.results
            this.totalItems = json.count
          } else {
            this.contatos = []
            this.totalItems = 0
          }
        })
    }
  },
  beforeMount () {
    this.carregarContatos()
  },
  watch: {
    'pagination.page' (val) {
      this.carregarContatos()
    },
    searching (val) {
      if (!val) {
        this.filtro = ''
        this.campoPesquisa = ''
      }
    }
  }
}
</script>
